<template>
  <el-select v-model="uid" value-key="uid" filterable :multiple="multiple" clearable :placeholder="placeholder" class="user-filter" style="width: 100%" @change="handleChange">
    <el-option v-for="item in options" :key="item.uid" :label="item.username" :value="item.uid">
      <div class="flex align-items-center">
        <f-user-avatar :user="item" size="mini"></f-user-avatar>
        <span class="ml-sm">{{ item.username }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getAllUser } from '@/api/sys/userApi'
export default {
  name: 'SysUserSelector',

  props: {
    value: {
      type: [Number, Array],
      default() {
        return undefined
      }
    },

    placeholder: {
      type: String,
      default: '请选择'
    },

    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      options: []
    }
  },

  computed: {
    uid: {
      get() {
        if (this.multiple) {
          return this.value && this.value.length ? this.value : []
        } else {
          return this.value ? this.value : null
        }
      },
      set(val) {
        if (this.multiple) {
          this.$emit('input', val && val.length ? val : [])
        } else {
          this.$emit('input', val ? val : null)
        }
      }
    }
  },

  watch: {},

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      getAllUser().then(res => {
        if (!res.errno) {
          this.options = res.data.list
        }
      })
    },

    handleChange(e) {
      this.$emit('change', e)
    }
  }
}
</script>
